<template>
  <v-container>
    <v-row dense v-if="this.computedSummarizedFlow">
      <v-col>
        <field-label label="MDA" class="fill-height d-flex flex-column">
          <span
            class="big-number mt-auto"
            :class="{
              'big-number--negative': computedMda === '+',
              'grey--text text-lighten-1': computedMda === '?',
            }"
            >{{ computedMda }}</span
          >
        </field-label>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <field-label label="ASAS axial" class="fill-height d-flex flex-column">
          <span
            class="big-number mt-auto"
            :class="{
              'big-number--negative': computedAsasAxial === '+',
              'grey--text text-lighten-1': computedAsasAxial === '?',
            }"
            >{{ computedAsasAxial }}</span
          >
        </field-label>
      </v-col>
      <v-col>
        <field-label label="Sacroileíte em imagem">
          <span
            class="big-number"
            :class="{
              'big-number--negative': computedSacroileiteImagem === '+',
              'grey--text text-lighten-1': computedSacroileiteImagem === '?',
            }"
            >{{ computedSacroileiteImagem }}</span
          >
        </field-label>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <field-label label="Características espondiloartrite">
          <span class="big-number" :class="[computedCaracteristicasClass]">{{ computedCaracteristicas }}</span>
        </field-label>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <field-label label="CASPAR">
          <span
            class="big-number"
            :class="{ 'big-number--negative': computedCaspar > 2, 'grey--text text-lighten-1': computedCaspar === '?' }"
            >{{ computedCaspar }}</span
          >
        </field-label>
      </v-col>
      <v-col>
        <field-label label="BASDAI">
          <span
            class="big-number"
            :class="{
              'big-number--negative': computedBasdai >= 4,
              'grey--text text-lighten-1': computedBasdai === '?',
            }"
            >{{ computedBasdai }}</span
          >
        </field-label>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <field-label label="ASDAS PCR">
          <span class="big-number" :class="[computedAsdasPcrClass]">{{ computedAsdasPcr }}</span>
        </field-label>
      </v-col>
      <v-col>
        <field-label label="ASDAS VHS">
          <span class="big-number" :class="[computedAsdasVhsClass]">{{ computedAsdasVhs }}</span>
        </field-label>
      </v-col>
      <v-col>
        <field-label label="EVA">
          <span class="big-number" :class="[computedEvaClass]">{{ computedEva }}</span>
        </field-label>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseSummary from '../../general/summary/BaseSummary.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import axialMixin from '@/components/AttendanceForm/espondiloartrites/mixins/espondiloartritesAxialAsasMixin'

export default {
  extends: BaseSummary,
  mixins: [axialMixin],
  components: { FieldLabel },
  computed: {
    computedCaracteristicasClass() {
      if (this.computedCaracteristicas === '?') {
        return 'grey--text text-lighten-1'
      }
      if (this.computedCaracteristicas > 0 && this.computedCaracteristicas <= 2) {
        return 'yellow--text'
      } else if (this.computedCaracteristicas > 2) {
        return 'big-number--negative'
      }

      return ''
    },

    computedAsdasPcrClass() {
      if (this.computedAsdasPcr === '?') {
        return 'grey--text text-lighten-1'
      }

      if (this.computedAsdasPcr > 1.3 && this.computedAsdasPcr < 2.1) {
        return 'yellow--text'
      } else if (this.computedAsdasPcr >= 2.1 && this.computedAsdasPcr <= 3.5) {
        return 'orange--text'
      } else if (this.computedAsdasPcr > 3.5) {
        return 'big-number--negative'
      }

      return ''
    },

    computedAsdasVhsClass() {
      if (this.computedAsdasVhs === '?') {
        return 'grey--text text-lighten-1'
      }

      if (this.computedAsdasVhs > 1.3 && this.computedAsdasVhs < 2.1) {
        return 'yellow--text'
      } else if (this.computedAsdasVhs >= 2.1 && this.computedAsdasVhs <= 3.5) {
        return 'orange--text'
      } else if (this.computedAsdasVhs > 3.5) {
        return 'big-number--negative'
      }

      return ''
    },

    computedMdaClass() {
      if (this.computedMda === '?') {
        return 'grey--text text-lighten-1'
      }

      if (this.computedMda === '+') {
        return 'orange--text'
      } else if (this.computedMda === '-') {
        return 'yellow--text'
      }

      return ''
    },
  },

  methods: {
    getSummaryData() {
      return {
        asasAxial: { value: this.computedAsasAxial ?? '', text: 'ASAS axial' },
        sacroileiteImagem: { value: this.computedSacroileiteImagem ?? '', text: 'Sacroileíte em imagem' },
        caracteristicas: { value: this.computedCaracteristicas ?? '', text: 'Características espondiloartrite' },
        caspar: { value: this.computedCaspar ?? '', text: 'CASPAR' },
        basdai: { value: this.computedBasdai ?? '', text: 'BASDAI' },
        asdasPcr: { value: this.computedAsdasPcr ?? '', text: 'ASDAS PCR' },
        asdasVhs: { value: this.computedAsdasVhs ?? '', text: 'ASDAS VHS' },
        eva: { value: this.computedEva ?? '', text: 'EVA' },
        mda: { value: this.computedMda, text: 'MDA' },
      }
    },
  },
}
</script>

<style scoped>
.big-number {
  font-weight: medium;
  color: green;
  font-size: 2.5rem;
}
.big-number--negative {
  color: red;
}
</style>
